import { Attr, BelongsTo, Model } from "spraypaint";

import { SocialPlatform } from "shared/constants/social";
import { ApplicationRecord } from "shared/services/spraypaint";
import type { Nullable } from "shared/types";

import type Organisation from "./Organisation";
import { type SocialMetadata } from "./SocialMetadata";

@Model({ apiNamespace: "/social_integrations", endpoint: "/twitter" })
class TwitterSocialIntegration extends ApplicationRecord {
  static jsonapiType = "twitter_social_integrations";

  @Attr() archived: boolean;

  @Attr() archivedAt: string;

  @Attr({ persist: false }) draftPosts: number;

  @Attr() expiredAt: Nullable<string>;

  @Attr() expiresAt: Nullable<string>;

  @Attr() isOutreachAccount: boolean;

  @Attr() isSocialEngage: boolean;

  @Attr() isSocialListen: boolean;

  @Attr() label: string;

  @Attr() metadata: SocialMetadata;

  @BelongsTo() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() organisationTeamIds: number[];

  @Attr() remoteId: string;

  @Attr({ persist: false }) scheduledPosts: number;

  @Attr() socialPlatform: string;

  @Attr() token: string;

  @Attr({ persist: false }) tokenRefreshedAt: string;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() validUntil: Nullable<string>;

  platformIcon() {
    return `${import.meta.env.VITE_ASSETS_URL}/icons/twitter.svg`;
  }

  platformLabel(): SocialPlatform.TWITTER {
    return SocialPlatform.TWITTER;
  }
}

export default TwitterSocialIntegration;
